<script>
    export default {
        components: {
        }
    }
</script>

<template>
    <div id="page-view">
        <slot />
    </div>
</template>